const LOGIN_PATH = "/login";

export function getCurrentPathWithSearch() {
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}

export function buildLoginRedirectPath(returnTo = getCurrentPathWithSearch()) {
  const normalizedReturnTo =
    returnTo && returnTo !== LOGIN_PATH ? returnTo : "/";

  return `${LOGIN_PATH}?returnTo=${encodeURIComponent(normalizedReturnTo)}`;
}

export function clearClientSession() {
  sessionStorage.clear();
  localStorage.clear();

  if ("z__z" in window) {
    delete window["z__z"];
  }
}

export function redirectToLogin() {
  clearClientSession();

  if (window.location.pathname !== LOGIN_PATH) {
    window.location.assign(buildLoginRedirectPath());
  }
}
